// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

function PilotStemHeading(props) {
  return React.createElement("h1", {
              className: "mb-5 text-lg font-bold"
            }, props.children);
}

var make = PilotStemHeading;

export {
  make ,
}
/* react Not a pure module */
